const devConfig = {
  api: "https://uat.juicysuite.app/member/api/",
};

export default devConfig;
